import React, { useState, useRef } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Link, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { createMeetTheTeam } from "../../../api/axios";
import { Alert } from "react-bootstrap";
import Avetar from '../../../Assets/avetar.png'
import removeIcon from "../../../Assets/remove-image-photo.svg";
import FormGroup from "../../Common/FormGroup";
import { showToast } from "../../../Utills/toast";
import { useFormik } from "formik";
import * as Yup from "yup";

export default function MeetTeamCreate() {
  const {id, partnerId } = useParams();
  const [isUpdating, setIsUpdating] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      petName: "",
      ownerName: "",
      position: "",
      image: null
    },
    validationSchema: Yup.object({
      petName: Yup.string().required("Pet name is required"),
      ownerName: Yup.string().required("Owner name is required"),
      position: Yup.string().required("Position is required"),
    }),
    onSubmit: async (values) => {
      setIsUpdating(true);
      const formData = new FormData();
      formData.append("name", values.petName);
      if (values.image instanceof File) {
        formData.append("image", values.image);
      }
      formData.append("owner", values.ownerName);
      formData.append("position", values.position);
      formData.append("partner_id", partnerId);

      try {
        const response = await createMeetTheTeam(formData);
        formik.resetForm();
        if (inputRef.current) {
          inputRef.current.value = "";
        }
        showToast({
          type: 'success',
          message: response?.data?.message || "Meet the team section has been created successfully!",
        });
        setIsUpdating(false);
          navigate(`/${partnerId}/aboutus/meet_the_team/edit/${response.data.data.id}`);
      } catch (error) {
        showToast({
          type: 'error',
          message: error?.response?.data?.message || "Failed to create meet the team section. Please try again.",
        });
        setIsUpdating(false);
      }
    }
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      formik.setFieldValue("image", file);
    }
  };

  const handleImageDelete = () => {
    formik.setFieldValue("image", null);
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return (
    <FormWrapper>
      <Form onSubmit={formik.handleSubmit}>
        <Title>Create Meet the Team Section</Title>
        <SliderDiv>
          <Row className="mb-3">
            <Col md={4}>
              <FormGroup>
                <Row>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                    ref={inputRef}
                  />
                  {formik.values.image ? (
                    <ImageWrapper>
                      <UploadImage>
                        <BootstrapImage
                          src={URL.createObjectURL(formik.values.image)}
                          alt="Team member"
                          onClick={() => inputRef.current?.click()}
                        />
                      </UploadImage>
                      <RemoveButtonWrapper>
                        <BootstrapButton
                          type="button"
                          className="w-auto m-0"
                          onClick={handleImageDelete}
                        >
                          <img src={removeIcon} alt="removeImage" height={'20px'} width={'20px'}/>
                        </BootstrapButton>
                      </RemoveButtonWrapper>
                    </ImageWrapper>
                  ) : (
                    <BootstrapImage
                      src={Avetar}
                      alt="Default avatar"
                      onClick={() => inputRef.current?.click()}
                      onMouseEnter={(e) => {
                        e.target.style.opacity = 0.8;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.opacity = 1;
                      }}
                    />
                  )}
                </Row>
              </FormGroup>
            </Col>
            
            <Col style={{ marginTop: "1.2vw" }}>
              <FormGroup 
                controlId="TeamPetName" 
                label="Pet Name"
                requiredField={true}
                error={formik.touched.petName && formik.errors.petName}
              >
                <Form.Control
                  type="input"
                  {...formik.getFieldProps("petName")}
                  isInvalid={formik.touched.petName && formik.errors.petName}
                />
              </FormGroup>
         
              <FormGroup 
                label='Owner'
                requiredField={true}
                error={formik.touched.ownerName && formik.errors.ownerName}
              >
                <Form.Control
                  type="input"
                  {...formik.getFieldProps("ownerName")}
                  isInvalid={formik.touched.ownerName && formik.errors.ownerName}
                />
              </FormGroup>
           
              <FormGroup 
                label='Owner Position'
                requiredField={true}
                error={formik.touched.position && formik.errors.position}
              >
                <Form.Control
                  type="input"
                  {...formik.getFieldProps("position")}
                  isInvalid={formik.touched.position && formik.errors.position}
                />
              </FormGroup>
            </Col>
          </Row>
          <ButtonWrapper>
            <Link to={`/${partnerId}/aboutus/meet_the_team/view/${Number(id) ? id : 'create'}`}>
              <Button variant="secondary">Go Back</Button>
            </Link>
            <div>
              <Button type="submit" disabled={isUpdating}>
                {isUpdating ? "Saving..." : "Save Changes"}
              </Button>
            </div>
          </ButtonWrapper>
        </SliderDiv>
      </Form>
    </FormWrapper>
  );
}

const FormWrapper = styled.div`
@media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;


const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 2rem;
`;
const RemoveButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
   position: absolute;
    top: -17px;
    right: -14px;
    @media (max-width:576px) {
     top: -9px;
    right: -17px;}
`;
const BootstrapImage = styled('img')(({ theme }) => ({
  maxWidth: "13vw",
  cursor: "pointer",
  "@media (max-width: 576px)": {
    maxWidth: "60vw",
  },
}));

const UploadImage = styled.div`
  max-width: 13vw;
   overflow: hidden;
  border-radius: 6px;
  @media (max-width:576px) {
   max-width: 60vw;
  }
`;
const ImageWrapper = styled.div`
    position:relative;
    max-width: 13vw;
   @media (max-width:576px) {
   max-width: 60vw;
  }
`;

const  BootstrapButton = styled('button')(({ theme }) => ({
  margin: '0 !important',
  backgroundColor:'#FFFFFF',
  padding: '5px 7px',
  border: '1px solid #dc3545',
  "&:hover": {
    background: '#fffeff',
    boxShadow:'rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px'
  },
  '@media (max-width:576px)': {
    padding: '2px 4px',
  },
}));